import subestacion from "../../../../assets/images/productos/subestacionMovil/SubMovil.png";
import qr from "../../../../assets/images/QR Daniel Montes.svg";
import Producto from "../../../../components/producto";

import pic1 from "../../../../assets/images/productos/subestacionMovil/Mosaico - SM1.jpg";
import pic2 from "../../../../assets/images/productos/subestacionMovil/Mosaico - SM2.jpg";
import pic3 from "../../../../assets/images/productos/subestacionMovil/Mosaico - SM3.jpg";
import pic4 from "../../../../assets/images/productos/subestacionMovil/Mosaico - SM4.jpg";

import { useTranslation } from "react-i18next";

function SubestacionMovil() {

    const {t} = useTranslation();

  return (
    <Producto
      fotos={[pic1, pic2, pic3, pic4]}
      datosTabla1={[
        [t("tensionMaximaDeServicio"), "kV", "36"],
        [t("corrienteNominal"), "A", "4.000"],
        [t("corrienteBreveDuracion"), "kA", "40"],
      ]}
      datosTabla2={[]}
      nombreProducto={"Subestacion Movil"}
      fotoProducto={subestacion}
      descripcionProducto={
       t("subestacionMovil.titulo_descripcion")}
      caracteristicas={[
        t("subestacionMovil.bullet1"),
        t("subestacionMovil.bullet2"),
        t("subestacionMovil.bullet3"),
        t("subestacionMovil.bullet4"),
        t("subestacionMovil.bullet5")
      ]}
      vendedor={{
        nombre: "Daniel Montes",
        telefono: "+54 9 11 3167-6868",
        mail: "dmontes@ema.com.ar",
        qr: qr,
      }}
      pathPdf={'/assets/docs/2025%20-%20Subestación%20Móvil.pdf'}
      tieneTabla2={false}
    />
  );
}

export default SubestacionMovil;